import React from 'react';
import { PreHeader } from '../components/sections/PreHeader';
import { Hero } from '../components/sections/Hero';
import { Hook } from '../components/sections/Hook';
import { Problem } from '../components/sections/Problem';
import { Mechanism } from '../components/sections/Mechanism';
import { WhatYouGet } from '../components/sections/WhatYouGet';
import { TargetAudience } from '../components/sections/TargetAudience';
import { HowItWorks } from '../components/sections/HowItWorks';
import { Proof } from '../components/sections/Proof';
import { FAQ } from '../components/sections/FAQ';
import { Offer } from '../components/sections/Offer';
import { Footer } from '../components/sections/Footer';
export function SaludDoradaPage() {
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-brown selection:bg-brand-gold/30" data-id="element-190">
      <PreHeader data-id="element-191" />
      <Hero data-id="element-192" />
      <Hook data-id="element-193" />
      <Problem data-id="element-194" />
      <Mechanism data-id="element-195" />
      <WhatYouGet data-id="element-196" />
      <TargetAudience data-id="element-197" />
      <HowItWorks data-id="element-198" />
      <Proof data-id="element-199" />
      <FAQ data-id="element-200" />
      <Offer data-id="element-201" />
      <Footer data-id="element-202" />
    </div>;
}